import {
  Selectors,
  getState,
} from '@eCommerce/frontend-legacy-shared-library-native';
import {Platform} from 'react-native';
import {select, delay, call} from 'redux-saga/effects';
import {APICallState} from 'services/api/api';

const {
  authenticationStateSelector,
  isWebViewAuthSelector,
  sectokenSelector,
  patrontokenSelector,
} = Selectors;

export function* waitForAuthStateResolution() {
  let authState = yield call(getState, authenticationStateSelector);
  if (authState === APICallState.LOADING) {
    let totalTimeElapsed = 0;
    while (
      authState !== APICallState.SUCCESS &&
      authState !== APICallState.ERROR &&
      totalTimeElapsed < 10000
    ) {
      authState = yield call(getState, authenticationStateSelector);
      yield delay(500);
      totalTimeElapsed += 500;
    }
  }
}

export function* getAuthTokenSaga() {
  const isWebViewAuth = yield call(getState, isWebViewAuthSelector);

  if (Platform.OS === 'web' && !isWebViewAuth) {
    yield call(waitForAuthStateResolution);

    const authState = yield call(getState, authenticationStateSelector);
    if (authState !== APICallState.SUCCESS) {
      return '';
    }
  }

  let token;
  if (Platform.OS === 'web' && !isWebViewAuth) {
    token = yield call(getState, sectokenSelector);
  } else {
    // Native request or WebViewAuth request
    token = yield call(getState, patrontokenSelector);
  }

  return token;
}

export function* getRaaSOrOAuthTokenSaga() {
  const isRaaSToken = yield call(getState, Selectors.isRaaSTokenSelector);
  let token;

  if (!isRaaSToken) {
    token = yield call(getState, Selectors.webviewPatronTokenSelector) ?? '';
    return token;
  }

  token = yield call(getAuthTokenSaga);

  return token;
}
